import * as actions from './actionTypes'

//保存新添加设备信息
export const addDeviceList=(data)=>({
  type:actions.DEVICEMANAGEMENT_ADD_DEVICE_LIST,
  data,
})